import Reflux from 'reflux';
import actions from '../actions';

// stateless store
export default Reflux.createStore({
	listenables: actions,

	init() {
		// console.log('__init accessory count store');
		this.state = {};
	},

	getState() {
		return this.state;
	},

	getInitialState() {
		return this.getState();
	},

	onLoadAccessoryCountCompleted(data) {
		this.state = data.body;
		this.output();
	},

	output() {
		this.trigger(this.getState());
	}
});
